// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E2iO1 {
  background-color: #f5f5f5 !important;
  color: #999 !important;
  border-color: #f5f5f5 !important;
  cursor: not-allowed !important;
  font-weight: 500;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countingDown": `E2iO1`
};
export default ___CSS_LOADER_EXPORT___;
